import { render, staticRenderFns } from "./ItemOfRooms.vue?vue&type=template&id=18812189"
import script from "./ItemOfRooms.vue?vue&type=script&lang=js"
export * from "./ItemOfRooms.vue?vue&type=script&lang=js"
import style0 from "./ItemOfRooms.vue?vue&type=style&index=0&id=18812189&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports